<div
  class="fade modal-lg modal"
  id="userConfigModal"
  tabindex="-1"
  aria-labelledby="userConfigModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header w-100 d-flex justify-content-between">
        <h1 class="modal-title fs-5">Configuración del usuario</h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body" *ngIf="user">
        <h6>Datos del Usuario</h6>
        <div class="d-flex w-100 justify-content-center">
          <div class="user-info-wrapper col-10 row">
            <div class="col-lg-6 col-12">
              <span><strong>Email: </strong>{{ user.email }}</span>
            </div>

            <div class="col-lg-6 col-12">
              <span><strong>Teléfono: </strong>{{ user.phoneNumber }}</span>
            </div>

            <div class="col-lg-6 col-12">
              <span><strong>Genero: </strong>{{ user.gender }}</span>
            </div>

            <div class="col-lg-6 col-12">
              <span><strong>DNI: </strong>{{ user.dni }}</span>
            </div>

            <div class="col-lg-6 col-12">
              <span
                ><strong>Fecha de Nacimiento: </strong
                >{{ user.parsedBirthdate }}</span
              >
            </div>
          </div>
        </div>

        <h6 class="mt-4">Configuración</h6>

        <div class="row">
          <div class="col-lg-6 col-12">
            <select
              class="form-select"
              aria-label="Small select example"
              [formControl]="userRole"
              (change)="changeRol()"
            >
              <option selected value="BFF_USER_TRAINER">Entrenador</option>
              <option selected value="BFF_USER_TRAINER_PREMIUM">
                Entrenador Premium
              </option>
              <option selected value="BFF_USER_NUTRITIONIST">
                Nutricionista
              </option>
              <option selected value="BFF_USER_NUTRITIONIST_PREMIUM">
                Nutricionista Premium
              </option>
              <option selected value="BFF_USER_TRAINER_NUTRITIONIST">
                Entrenador Nutricionista
              </option>
              <option selected value="BFF_USER_TRAINER_NUTRITIONIST_PREMIUM">
                Entrenador Nutricionista Premium
              </option>
              <option value="BFF_USER_TRAINER_NUTRITIONIST_PREMIUM_ADMIN">
                Administrador
              </option>
              <option selected value="USER">Usuario</option>
            </select>
          </div>

          <div class="row">
            <div class="col-lg-6 col-12 mt-2 mt-lg-0">
              <button
                class="btn-custom w-100 mt-2"
                (click)="obtainUserFormData()"
              >
                <div
                  *ngIf="user.sendingEmail"
                  class="spinner-border"
                  role="status"
                >
                  <span class="visually-hidden">Loading...</span>
                </div>
                <span *ngIf="!user.sendingEmail"
                  >Obtener información del usuario</span
                >
              </button>

              <button class="btn-custom w-100 mt-2" (click)="showUserForms()">
                Ver información de formularios
              </button>
            </div>
          </div>
        </div>

        <div class="w-100 d-flex justify-content-center">
          <table class="table mt-5">
            <thead>
              <tr>
                <th>Plan</th>
                <th>Semanas</th>
                <th>Fecha de Inicio</th>
                <th>Fecha Finalizacion</th>
                <th>Estado</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of user.planHistory">
                <td>{{ p.name }}</td>
                <td>{{ p.weeks }}</td>
                <td>{{ p.planStartAtParsed }}</td>
                <td>{{ p.planFinishAtParsed }}</td>
                <td>{{ p.status }}</td>
                <td>
                  <button
                    class="btn btn-danger btn-sm"
                    (click)="finishPlan(p.id!)"
                    *ngIf="p.status != 'FINISHED'"
                  >
                    Finalizar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <button
          class="btn-custom-outline w-100"
          data-bs-toggle="modal"
          data-bs-target="#planCreateModal"
        >
          + Agregar Plan
        </button>
      </div>
    </div>
  </div>
</div>
